import React from 'react';
import { Col, Row, Form} from 'react-bootstrap';

const TransactionDetailField = (props) => {
    return (
            <Row>
                <Col sm={12}>
                    <Form.Group controlId={props.id}>
                        <Row>
                            <Col sm={5} className="text-grey font-weight-bold medium text-right pt-2">
                                {props.fieldName}
                            </Col>
                            <Col sm={6}>
                                <Form.Control className={props.right ? "text-right" : ""} name={props.id} type="text" value={props.value} disabled/>
                            </Col>
                        </Row>
                    </Form.Group>
                </Col>
            </Row>
        );
}

export default TransactionDetailField;